import { render } from "./TariffCard.vue?vue&type=template&id=517ca9ea"
import script from "./TariffCard.vue?vue&type=script&lang=js"
export * from "./TariffCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__